<template>
  <n-menu :options="menuOptions" :value="activeKey" @update:value="handleSelect" />
</template>

<script setup>
import { h, computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { NIcon } from 'naive-ui'

import {
  BulbOutline,
  HomeOutline,
  PersonOutline,
  BusinessOutline,
  FlaskOutline,
} from '@vicons/ionicons5'

const router = useRouter()
const route = useRoute()

// Compute activeKey based on current route.
// This will ensure that the menu reflects the current route.
const activeKey = computed(() => {
  const matchedName = router.resolve(route.path).name

  // Falls back to 'home' if no route matches or if the path is '/'.
  // Need to add a 'Not-Found' route in the future.
  if (matchedName === 'home' || !matchedName) {
    return 'home'
  }
  // Handle other route paths are same as the menu keys.
  // For example, if the route is '/production/products',
  // the menu key should be 'production/products'.
  return route.path.substring(1)
})

const renderIcon = (icon) => {
  return () => h(NIcon, null, { default: () => h(icon) })
}

const devMode = import.meta.env.DEV

// Define menu options with icons.
// Make sure the keys match the route names in router configuration.
const menuOptions = [
  { label: 'Home', key: 'home', icon: renderIcon(HomeOutline) },
  {
    label: 'Inventory',
    key: 'production',
    icon: renderIcon(BusinessOutline),
    children: [
      { label: 'Parts', key: 'production/products' },
      { label: 'Lots', key: 'production/lots' },
      { label: 'Locations', key: 'production/locations' },
      { label: 'Orders', key: 'production/orders' },
    ],
  },
  {
    label: 'Design',
    key: 'design',
    icon: renderIcon(BulbOutline),
    children: [
      { label: 'Variants', key: 'design/variants' },
      { label: 'Sequins', key: 'design/sequins' },
      { label: 'Groups', key: 'design/groups' },
      { label: 'Blends', key: 'design/blends' },
    ],
  },
  {
    label: 'Design',
    key: 'design',
    icon: renderIcon(BulbOutline),
    children: [{ label: 'Variants', key: 'design/variants' }],
  },
  { label: 'Profile', key: 'profile', icon: renderIcon(PersonOutline) },
  // Add Demo or unreleased feature in dev mode only
  ...(devMode ? [{ label: 'Demo', key: 'demo/table', icon: renderIcon(FlaskOutline) }] : []),
]

const handleSelect = (key) => {
  router.push('/' + key)
}
</script>
